var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "instance", class: { selected: _vm.selected } },
    [
      _c(
        "div",
        {
          staticClass: "self selectable-item",
          class: { selected: _vm.selected },
          style: { paddingLeft: _vm.depth * 15 + "px" },
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.inspect(_vm.routeId)
            },
            dblclick: _vm.toggleExpand
          }
        },
        [
          _c("span", { staticClass: "content" }, [
            _vm.route.children && _vm.route.children.length
              ? _c(
                  "span",
                  {
                    staticClass: "arrow-wrapper",
                    on: { click: _vm.toggleExpand }
                  },
                  [
                    _c("span", {
                      staticClass: "arrow right",
                      class: { rotated: _vm.expanded }
                    })
                  ]
                )
              : _vm._e(),
            _c("span", { staticClass: "instance-name" }, [
              _vm._v("\n        " + _vm._s(_vm.route.path) + "\n      ")
            ])
          ]),
          _vm.route.name
            ? _c("span", { staticClass: "info name" }, [
                _vm._v("\n      " + _vm._s(_vm.route.name) + "\n    ")
              ])
            : _vm._e(),
          _vm.route.alias
            ? _c("span", { staticClass: "info alias" }, [
                _vm._v("\n      alias: "),
                _c("b", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.formattedValue(_vm.route.alias, false)
                    )
                  }
                })
              ])
            : _vm._e(),
          _vm.route.redirect
            ? _c("span", { staticClass: "info redirect" }, [
                _vm._v("\n      redirect: "),
                _c("b", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.formattedValue(_vm.route.redirect, false)
                    )
                  }
                })
              ])
            : _vm._e(),
          _vm.isActive
            ? _c("span", { staticClass: "info active" }, [
                _vm._v("\n      active\n    ")
              ])
            : _vm._e()
        ]
      ),
      _vm.expanded
        ? _c(
            "div",
            _vm._l(_vm.route.children, function(child, key) {
              return _c("routes-tree-item", {
                key: child.path,
                attrs: {
                  route: child,
                  "route-id": _vm.routeId + "_" + key,
                  depth: _vm.depth + 1
                }
              })
            }),
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }